import { render, staticRenderFns } from "./ManagementDialog.vue?vue&type=template&id=cbbf99fc&scoped=true"
import script from "./ManagementDialog.vue?vue&type=script&lang=js"
export * from "./ManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./ManagementDialog.vue?vue&type=style&index=0&id=cbbf99fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf99fc",
  null
  
)

export default component.exports